export const iconFontAwesomeGamingChessBoard = (
	<i className="fa-solid fa-chess-board"></i>
);
